export default "__VITE_ASSET__644db279__"